@let checkInStage = checkInFeature.selectors.checkInStage.asSignal();

@if (checkInStage === 'current-mood') {
  <atn-check-in-mood-pop-up />
} @else if (checkInStage === 'full-check-in') {
  <atn-check-in-modal />
}
